/* ROLES */
export const GET_CARPARKS = "GET_CARPARKS"
export const GET_CARPARKS_SUCCESS = "GET_CARPARKS_SUCCESS"
export const GET_CARPARK_FAIL = "GET_CARPARK_FAIL"

/* ROLES DETAIL*/
export const GET_CARPARK_DETAIL = "GET_CARPARK_DETAIL"
export const GET_CARPARK_DETAIL_SUCCESS = "GET_CARPARK_DETAIL_SUCCESS"
export const GET_CARPARK_DETAIL_FAIL = "GET_CARPARK_DETAIL_FAIL"

/**
 * ADD ROLE
 */
export const ADD_NEW_CARPARK = "ADD_NEW_CARPARK"
export const ADD_CARPARK_SUCCESS = "ADD_CARPARK_SUCCESS"
export const ADD_CARPARK_FAIL = "ADD_CARPARK_FAIL"

/**
 * EDIT ROLE
 */
export const UPDATE_CARPARK = "UPDATE_CARPARK"
export const UPDATE_CARPARK_SUCCESS = "UPDATE_CARPARK_SUCCESS"
export const UPDATE_CARPARK_FAIL = "UPDATE_CARPARK_FAIL"

/**
 * Delete user
 */
export const DELETE_CARPARK = "DELETE_CARPARK"
export const DELETE_CARPARK_SUCCESS = "DELETE_CARPARK_SUCCESS"
export const DELETE_CARPARK_FAIL = "DELETE_CARPARK_FAIL"

/**
 * CLEAR MESSAGE AND ERROR OBJECT
 */
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"

/**
 * Occupancy Rate
 */
export const GET_CARPARK_OCCUPANCY_RATE = "GET_CARPARK_OCCUPANCY_RATE";
export const GET_CARPARK_OCCUPANCY_RATE_SUCCESS = "GET_CARPARK_OCCUPANCY_RATE_SUCCESS";
export const GET_CARPARK_OCCUPANCY_RATE_FAIL = "GET_CARPARK_OCCUPANCY_RATE_FAIL";
export const GET_EXPORT_OCCUPANCY_RATE="GET_EXPORT_OCCUPANCY_RATE;"
export const GET_EXPORT_OCCUPANCY_RATE_SUCCESS = "GET_EXPORT_OCCUPANCY_RATE_SUCCESS";
export const GET_EXPORTED_OCCUPANCY_RATE_FAIL = "GET_EXPORTED_OCCUPANCY_RATE_FAIL";
export const RESET_EXPORT_DATA="RESET_EXPORT_DATA";
